import React, { useContext } from 'react';

import LazyImage from 'components/LazyImage';
import { Reporter } from 'features/dataCapture';
import { ProductImpressionsContext } from 'features/tealium';

import useProductOffering from './useProductOffering';

import './ProductItemImage.scss';

type ProductItemImageProps = {
	product: LP.product.ProductItem;
	sortPosition?: number;
	width?: number;
	height?: number;
	skipMainProductSkuView?: boolean
}

function ProductItemImage ({
	product, children, sortPosition, width = 274, height = 274, skipMainProductSkuView = false
}: React.PropsWithChildren<ProductItemImageProps>) {

	const dataCaptureReporter = window.lp.dataCapture.reporter;
	const { productImpressionsReporter, productImpressionsReporterGA4 } = useContext(ProductImpressionsContext);

	const imageSource = product.ExtraLargeImageUrl;

	const productOffering = useProductOffering((currentRef) => {

		if (!dataCaptureReporter.isSkuViewRecorded(currentRef)
			&& (!skipMainProductSkuView || (skipMainProductSkuView && !product.IsMainProduct))) {

			const data = Reporter.getSkuViewData(currentRef);
			dataCaptureReporter.track(data);

		}
		if (productImpressionsReporter) {

			const record = productImpressionsReporter.getProductImpressionDataFromElement(currentRef);
			productImpressionsReporter.track(record);

		}
		if (productImpressionsReporterGA4) {

			const record = productImpressionsReporterGA4.getProductImpressionDataFromElement(currentRef);
			productImpressionsReporterGA4.track(record);

		}

	});

	return (
		<div
			className="ProductItemImage"
			ref={productOffering.setRefs}
			data-sku={product.ShortSku}
			data-name={product.ProductName}
			data-price={product.Price}
			data-position={sortPosition}
			data-primary-category={product.PrimaryCategory}
			data-primary-color={product.PrimaryColor}
			data-primary-finish={product.PrimaryFinish}
			data-primary-type={product.PrimaryType}
			data-primary-style={product.PrimaryStyle}
			data-widget-name={null}
			data-vendor-widget={null}
			data-sku-input-type={product.SkuInputType}
			data-is-open-box={product.IsOpenBox ? '1' : '0'}
		>
			<LazyImage
				alt={product.ProductName}
				data-sku={product.ShortSku}
				src={imageSource}
				width={width}
				height={height}
			/>
			{children}
		</div>
	);

}

export default ProductItemImage;
